<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="180px">
            <el-form-item label="出厂编号：" prop="factory_code">
                <span>{{model.factory_code}}</span>
            </el-form-item>
            <el-form-item label="pbpd：" prop="brand">
                <span>{{model.brand}}</span>
            </el-form-item>
            <el-form-item label="设备型号：" prop="device_code">
                <span>{{model.device_code}}</span>
            </el-form-item>
            <el-form-item label="借调前所在项目：" prop="alias">
                <span>{{project}}</span>
            </el-form-item>
            <el-form-item label="借调后所在项目：" prop="new_project_id">
                <el-select v-model="model.new_project_id" placeholder="请选择" clearable filterable style="width: 300px">
                    <el-option v-for="item in projectList" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById, saveModel } from '@/api/common'
import { flowMeterBorrow } from '@/api/deviceuser'

export default {
    name: 'flowMeterEdit',
    mixins: [editutil],
    props: {
        device_type: {
            type: Number,
            default() {
                return -1;
            }
        },
    },
    data() {
        return {
            model: {
                device_type: '',
                factory_code: '',
                brand: '',
                device_code: '',
                state: '',
                check_date: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
                new_project_id: 0,
            },
            getObj:{
                url:'/api/admin/flowmeter/borrowInfo',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                new_project_id: [
                    {required: true, message: '请选择借调后的项目', trigger: 'blur'},
                ],
            },
            project: {},
            projectList: [],
        };
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.resetModel(this.form_name);
                this.loadData();
            }
        }
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    flowMeterBorrow(this.id, this.model.new_project_id).then(res=>{
                        if(res.code===1){
                            this.$msgs("借调成功！");
                            this.$emit("on-close",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data.flowMeter;
                        this.project = res.data.old_project
                        this.projectList = res.data.projectList
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
    }
};
</script>